export default __webpack_public_path__ + "static/media/Bracers of Recklessness.d8738e5a.jpg";